import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/authcontext";
import { GeneralProvider } from "./context/generalContext";
import { ProtectedRoute } from "./components/protectedroutes";
import { NavBarContainer } from "./components/NavBar/NavBarContainer";
import { Login } from "./components/Login/Login";
import { WhatsappLogo } from "./components/WhatsAppLogo/WhatsappLogo";
import { ToastContainer } from "./utils/appToast";
import Footer from "./Footer";

const Home = lazy(() =>
  import("./components/Home/Home").then((module) => ({ default: module.Home }))
);
const Ordenes = lazy(() =>
  import("./components/Ordenes/Ordenes").then((module) => ({ default: module.Ordenes }))
);
const AsistenciaTecnica = lazy(() =>
  import("./components/AsistenciaTecnica/AsistenciaTecnica").then((module) => ({ default: module.AsistenciaTecnica }))
);
const AltaProducto = lazy(() =>
  import(
    /* webpackPrefetch: true */
    "./components/AltaProducto/AltaProducto"
  ).then((module) => ({ default: module.AltaProducto }))
);
const Perfil = lazy(() =>
  import("./components/Perfil/Perfil").then((module) => ({ default: module.Perfil }))
);
const Terminos = lazy(() =>
  import("./components/terminos").then((module) => ({ default: module.Terminos }))
);
const VerificacionEmailPendiente = lazy(() =>
  import("./components/Login/VerificacionEmailPendiente").then((module) => ({ default: module.VerificacionEmailPendiente }))
);
const AuthAction = lazy(() =>
  import("./components/Login/AuthAction").then((module) => ({ default: module.AuthAction }))
);

const RouteFallback = () => (
  <div className="flex items-center justify-center min-h-[40vh]">
    <div className="spinner-border" role="status" />
  </div>
);

export default function App() {
  return (
    <AuthProvider>
      <GeneralProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </GeneralProvider>
    </AuthProvider>
  );
}

function Shell() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="spinner-border" role="status" />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col">
      <ToastContainer />
      {user && <NavBarContainer />}

      <main className="flex-1 py-4">
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={user ? <Navigate to="/home" replace /> : <Login />} />
            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/ordenes" element={<ProtectedRoute><Ordenes /></ProtectedRoute>} />
            <Route path="/asistenciaTecnica" element={<ProtectedRoute><AsistenciaTecnica /></ProtectedRoute>} />
            <Route path="/altaProducto" element={<ProtectedRoute><AltaProducto /></ProtectedRoute>} />
            <Route path="/perfil" element={<ProtectedRoute><Perfil /></ProtectedRoute>} />
            <Route path="/terminosycondiciones" element={<Terminos />} />
            <Route path="/verificacion-email" element={<VerificacionEmailPendiente />} />
            <Route path="/auth/action" element={<AuthAction />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>

        {user && <WhatsappLogo />}
      </main>

      <Footer />
    </div>
  );
}
